export function hasMessage(cand: any): cand is { message: string } {
  return !!cand && cand.hasOwnProperty('message');
}
